import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { BaseModalPageComponent } from '../../base-modal.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PeopleService, AuthService } from '../../shared/services';
import { Person } from '../../shared/models';

@Component({
    templateUrl: './edit-password.component.html',
    standalone: false
})
export class EditPasswordPageComponent extends BaseModalPageComponent implements OnInit {
  public person: Person;
  editForm: UntypedFormGroup;
  public processing = false;
  isFailed = false;

  constructor(location: Location, private router: Router, private auth: AuthService) {
    super(location);
  }

  ngOnInit(): void {
    this.initForm();
  }

  save(model: any): void {
    this.processing = true;
    this.auth.editPassword(model).subscribe((data) => {
      this.isFailed = data.status !== 200 ? true : false;
      this.processing = false;
    });
  }

  public cancel() {
    this.goToBack();
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      currentPassword: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
      confirmPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(4)])
    });
  }

  goToBack(): void {
    this.router.navigate([this.settingsRoute, 'editUser']);
  }
}
